export default __webpack_public_path__ + "static/media/april.75519e13.png";